export function isObject(arg: any): boolean {
	return arg.toString() === "[object Object]"
}
